import { render } from "./App.vue?vue&type=template&id=3e45e1a3"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3e45e1a3&lang=scss"

import exportComponent from "D:\\work\\首页\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__